import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import { connect } from 'react-redux'

import Header from '../components/Header/Header.js'
import Footer from '../components/Footer/Footer.js'
import Button from '../components/Button/Button.js'

import { showTooltip, hideTooltip } from '../actions/actions.export.js';

var pf_config = require('../pf_config.json');


class FeatureTable extends Component {
  constructor(props){
    super(props);

    this.state = {
      top: true
    }
    this.handleScroll = this.handleScroll.bind(this);
  }

  componentDidMount() {
    window.document.title = "Features Table - Pattycake";
    window.addEventListener('scroll', this.handleScroll);
    window.addEventListener('resize', this.handleScroll);
    
    this.handleScroll();
  }
  
  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleScroll);
    window.removeEventListener('resize', this.handleScroll);
  }

  handleScroll(event) {

    var tableRect = this.featureTableDiv.getBoundingClientRect();
    
    if(tableRect.y <= 0){
      var top = 0;
      if(this.state.show){
        var headerRect = this.fixedHeaderDiv.getBoundingClientRect();
        top = (tableRect.height - 48 - headerRect.height) + tableRect.y;
        if(top > 0) top = -2;
        // console.log(tableRect.y, top, top + tableRect.y);
      }
      this.setState({
        show: true,
        top: top,
        width: this.featureTableDiv.clientWidth
      });
    } else {
      this.setState({
        show: false,
        top: 0,
        width: this.featureTableDiv.clientWidth
      });
    }
  }

  render(){
    const { dispatch, user, team } = this.props;

    var features = [];
    var i;

    for(i in pf_config.features){
      if(pf_config.features[i].hide) continue;
      features.push(pf_config.features[i]);
    }

    features.sort((a,b)=>{
      var ta = 0;
      for(i in a.availability){
        ta += a.availability[i] ? 1 : 0
      }
      var tb = 0;
      for(i in b.availability){
        tb += b.availability[i] ? 1 : 0
      }

      if(ta > tb) return -1;
      if(ta < tb) return 1;
      return 0;
    })

    var table_header = <thead>
      <tr>

        <th className="" style={{verticalAlign:'bottom'}}>
          <span className="text-700 text-gs1 availability-title">Feature</span><br/>
          <span className="text-muted">What's included?</span>
        </th>

        {/* OPEN */}
        <th className="th-availability">
          <div className="availability-price">
            <div className="availability-price-number"><small className="">free</small></div>
            <div className="availability-price-description">upgrade anytime<br/>&nbsp;</div>
          </div>
          <div className="availability-title">{pf_config.plans.open.short_name}</div>
          <div className="availability-status">
            {
              (user.isLoggedIn && !user.roles.pro && !user.roles.enterprise) &&
              <strong className="text-primary"><i className="fas fa-check"/> Your Account</strong>
            }
            {
              !user.isLoggedIn ?
              <Link to="/sign-up">Sign Up <i className="fal fa-angle-right"/></Link>
              :
              <span>&nbsp;</span>
            }
          </div>
        </th>


        {/* PRO */}
        <th className="th-availability">
          <div className="availability-price">
            <div className="availability-price-number">
              <span className="dollar-sign">$</span>{pf_config.plans.pro.price}
            </div>
            <div className="availability-price-description">
              per month<br/> single user license
            </div>
          </div>
          <div className="availability-title">{pf_config.plans.pro.short_name}</div>
          <div className="availability-status">
            {
              (user.isLoggedIn && user.roles.pro) &&
              <strong className="text-primary"><i className="fas fa-check"/> Currently Pro</strong>
            }
            {
              (user.isLoggedIn && !user.roles.pro && !user.roles.enterprise) &&
              <Link to="/settings/my-account/upgrade-to-pro">Upgrade to Pro <i className="fal fa-angle-right"/></Link>
            }
            {
              !user.isLoggedIn &&
              <Link to={"/sign-up?after=" + window.btoa("/settings/my-account/upgrade-to-pro")}>Go Pro <i className="fal fa-angle-right"/></Link>
            }
          </div>
        </th>


        {/* TEAM */}
        <th className="th-availability">
          <div className="corner-ribbon corner-ribbon-top-right">
            ${pf_config.plans.teams.price / pf_config.plans.teams.seats} per user
          </div>
          
          <div className="availability-price">
            <div className="availability-price-number">
              <span className="dollar-sign">$</span>{pf_config.plans.teams.price}
            </div>
            <div className="availability-price-description">
              per month<br/> per {pf_config.plans.teams.seats} user license
            </div>
          </div>
          <div className="availability-title">{pf_config.plans.teams.short_name}</div>
          <div className="availability-status">
            {
              !user.isLoggedIn ?
              <Link to={"/sign-up?after=" + window.btoa("pattycake-for-forms-sign-up") + "&in=" + window.btoa("Pattycake for Firms") + "&tg=" + window.btoa("Let's get you setup.")}>
                <span>Setup Your Firm <i className="fal fa-angle-right"/></span>
              </Link>
              :
              (!user.roles.enterprise) && 
              <Link to="/pattycake-for-firms-sign-up">
                {
                  team.hasTeams ? 
                  <strong className="text-primary"><i className="fas fa-check"/> Create Another <i className="fal fa-angle-right"/></strong>
                  :
                  <span>Setup Your Firm <i className="fal fa-angle-right"/></span>
                }
              </Link>
            }
          </div>
        </th>


        {/* ENTERPRISE */}
        {/*<th className="th-availability">
          
          <div className="availability-price">
            <div className="availability-price-number">
              <span className="dollar-sign">$</span>{pf_config.plans.enterprise.price}
            </div>
            <div className="availability-price-description">
              per month<br/> company-wide license
            </div>
          </div>
          <div className="availability-title">{pf_config.plans.enterprise.short_name}</div>
          <div className="availability-status">
            {
              !user.isLoggedIn ?
              <Link to={"/sign-up?after=" + window.btoa("pattycake-enterprise-sign-up") + "&in=" + window.btoa("Pattycake Enterprise") + "&tg=" + window.btoa("Let's get you setup.")}>
                Setup Your Enterprise <i className="fal fa-angle-right"/>
              </Link>
              :
              user.roles.enterprise ?
              <strong className="text-primary"><i className="fas fa-check"/> Your Account</strong>
              :
              <Link to="/pattycake-enterprise-sign-up">
                Setup Your Enterprise <i className="fal fa-angle-right"/>
              </Link>
            }
          </div>
        </th>*/}


      </tr>
    </thead>

    return <div className="landing">
      <div className="screen-height-container">
        <div className="shc-content">
          <Header transparent={true}/>
          <div className="container">
            <div className="row row-mega-padded">
              <div className="col-md-12">
                <h1 className="text-center">Detailed Plan Comparison</h1>
                <p className="text-center lead soft">
                  See which type of account is right for you.
                </p>
              </div>
            </div>
            <div className="row row-push-down">
              <div className="col-md-12">
                <div className="col-themed col-themed-shadow" style={{padding: 0}}>
                  <table className="table feature-table" ref={ (featureTableDiv) => this.featureTableDiv = featureTableDiv}>
                    { table_header }
                    <tbody>
                      {features.map((f, i)=>{
                        if(f.hide) return;
                        
                        return <tr key={i}>
                          <td>
                            <div className="flex-split">
                              <strong>{f.display_name}</strong>
                              <span
                                onMouseEnter={(e)=>{ 
                                  dispatch(showTooltip({
                                    e: e,
                                    position: 'top', 
                                    lag: 100,
                                    nobr: false,
                                    content: <div style={{width: 200}}>
                                      {f.description}
                                    </div>
                                  }))
                                }} 
                                onMouseLeave={(e)=>{ dispatch(hideTooltip()) }}
                                >
                                <i className="fal fa-question-circle text-grey-primary"/>
                              </span>
                            </div>
                          </td>
                          <td className="td-availability">{ f.availability.open ? <i className="fas fa-lg fa-check-circle fa-fw"/> : <i className="fal fa-lg fa-times fa-fw text-disabled"/>}</td>
                          <td className="td-availability">{ f.availability.pro ? <i className="fas fa-lg fa-check-circle fa-fw"/> : <i className="fal fa-lg fa-times fa-fw text-disabled"/>}</td>
                          <td className="td-availability">{ f.availability.teams ? <i className="fas fa-lg fa-check-circle fa-fw"/> : <i className="fal fa-lg fa-times fa-fw text-disabled"/>}</td>
                          {/*<td className="td-availability">{ f.availability.enterprise ? <i className="fas fa-lg fa-check-circle fa-fw"/> : <i className="fal fa-lg fa-times fa-fw text-disabled"/>}</td>*/}
                          
                        </tr>
                      })}
                    </tbody>
                  </table>
                 
                  {
                    this.state.show && 
                    <table className="table feature-table feature-table-fixed" style={{width: this.state.width, top: this.state.top}} ref={ (fixedHeaderDiv) => this.fixedHeaderDiv = fixedHeaderDiv}>
                      { table_header }
                    </table>
                  }
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="section-breaker">
        <div className="container">
          <div className="row row-padded justify-content-center">
            <div className="col-md-6">
              <div className="flex-center-column">
                <h2>Questions?</h2>
                <p className="soft lead text-center">Still wondering which plan is right for you?<br/>Have a great idea for a new feature?<br/>We'd love to hear from you.</p>
                <br/>
                <Link to="/contact" className="button-link">
                  <Button
                    display={<span>Get in touch&nbsp; <i className="fal fa-angle-double-right"/></span>}
                    color="grey"
                    size="large"
                  />
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer/>
    </div>
  }
}

const mapStateToProps = (state) => {
  const { user, team } = state;

  return {
    user, team
  }
}

export default connect(mapStateToProps)(FeatureTable);



// WEBPACK FOOTER //
// ./src/routes/FeatureTable.js